import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import type { ListBuildsResponse } from '@xver/apis/v1/kufer/builds/model';

export const BUILD_LIST_QUERY_KEY = 'apis.v1.kufer.builds.list';

interface UseBuildListQueryParams {
    containerId: string | undefined;
    page?: number;
    per_page?: number;
}

export function useBuildListQuery({
    containerId,
    page = 1,
    per_page = 20,
}: UseBuildListQueryParams) {
    const { isResolved } = useActiveProjectScope();
    return useQuery<ListBuildsResponse>({
        queryKey: [BUILD_LIST_QUERY_KEY, containerId, page, per_page],
        queryFn: () =>
            Endpoints.v1.Kufer.Builds.listBuilds(containerId as string, { page, per_page }),
        refetchInterval: 4000,
        enabled: !!containerId && isResolved,
    });
}
